import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import raabtaLogo from '@/assets/raabtalogo_white_bg.png';

export const LandingFooter: React.FC = () => {
    const location = useLocation();

    const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, targetId: string) => {
        if (location.pathname === '/') {
            e.preventDefault();
            const element = document.getElementById(targetId);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    };

    return (
        <footer className="raabta-footer">
            <div className="raabta-container">
                <div className="raabta-footer__grid">
                    <div className="raabta-footer__brand">
                        <Link to="/" className="raabta-brand">
                            <img 
                                src={raabtaLogo} 
                                alt="Raabta Logo" 
                                style={{ height: '28px', width: '28px', borderRadius: '50%', objectFit: 'contain' }} 
                            />
                            <span>Raabta</span>
                        </Link>
                        <p>School communication, simplified.</p>
                    </div>
                    <div className="raabta-footer__col">
                        <h4>Product</h4>
                        <Link to="/#features" onClick={(e) => handleLinkClick(e, 'features')}>Features</Link>
                        <Link to="/#workflow" onClick={(e) => handleLinkClick(e, 'workflow')}>Workflow</Link>
                        {/* <Link to="/#pricing" onClick={(e) => handleLinkClick(e, 'pricing')}>Pricing</Link> */}
                        {/* <Link to="/#roles">For Schools</Link> */}
                    </div>
                    <div className="raabta-footer__col">
                        <h4>Company</h4>
                        <Link to="/contact">Contact Us</Link>
                    </div>
                    <div className="raabta-footer__col">
                        <h4>Legal</h4>
                        <Link to="/privacy-policy">Privacy Policy</Link>
                        <Link to="/terms-of-service">Terms of Service</Link>
                        {/* <a href="#">Security</a> */}
                        <Link to="/delete-account" className="raabta-footer__link--danger">How To Delete Account In App</Link>
                    </div>
                </div>
                <div className="raabta-footer__bottom">
                    <span>© {new Date().getFullYear()} Raabta. All rights reserved.</span>
                    <span>Made with care for schools.</span>
                </div>
            </div>
        </footer>
    );
};
